import { Switch, Box } from '@cad-arc';
import { useFormContext, useWatch } from 'react-hook-form';
import { ServiceRotationOption } from '@mark43/cad-api';
import { useCallback } from 'react';
import { ServiceRotationFormType } from './types';
import { ServiceProviderSelect } from './service-provider-select';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function ManualSelectionSection({
    manuallySelectedServiceProvider,
    setManuallySelectedServiceProvider,
    recommendedServiceProvider,
}: {
    manuallySelectedServiceProvider?: ServiceRotationOption;
    setManuallySelectedServiceProvider: (provider?: ServiceRotationOption) => void;
    recommendedServiceProvider?: ServiceRotationOption;
}) {
    const isManualSelection = !!manuallySelectedServiceProvider;
    const form = useFormContext<ServiceRotationFormType>();
    const { enhancedServiceRotation: isEnhancedServiceRotationEnabled } = useEnabledFeatures();

    const serviceProviderOptions =
        useWatch({
            control: form.control,
            name: `${
                isEnhancedServiceRotationEnabled ? 'serviceRotationArea' : 'serviceRotationList'
            }.serviceRotationOptions`,
        }) ?? [];

    const toggleManualSelection = useCallback(
        (checked: boolean) => {
            if (checked) {
                setManuallySelectedServiceProvider(recommendedServiceProvider);
            } else {
                setManuallySelectedServiceProvider(undefined);
            }
        },
        [recommendedServiceProvider, setManuallySelectedServiceProvider]
    );

    return (
        <>
            <Box w="full" my="4">
                <Switch
                    isChecked={isManualSelection}
                    disabled={!recommendedServiceProvider}
                    onChange={(e) => toggleManualSelection(e.currentTarget.checked)}
                >
                    Manual selection
                </Switch>
            </Box>
            {isManualSelection && serviceProviderOptions && (
                <ServiceProviderSelect
                    value={manuallySelectedServiceProvider.value}
                    setValue={(option) => setManuallySelectedServiceProvider(option)}
                    options={serviceProviderOptions}
                />
            )}
        </>
    );
}
